// extracted by mini-css-extract-plugin
module.exports = {"summary":"Accordion_summary__2yAjR"};